import { Link } from "react-router-dom";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-cotton-100 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-heading text-4xl font-bold text-primary mb-8">
          Privacy Policy
        </h1>
        
        <div className="bg-white p-8 rounded-lg shadow-soft space-y-6">
          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">1. Introduction</h2>
            <p className="text-muted-foreground leading-relaxed">
              OGAS ("we", "our", "us") is committed to protecting your privacy. This Privacy Policy 
              explains how we collect, use, and safeguard your personal information when you visit 
              our website www.ogas.in and make purchases.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">2. Information We Collect</h2>
            <p className="text-muted-foreground leading-relaxed">
              We collect the following information when you place an order:
            </p>
            <ul className="list-disc list-inside text-muted-foreground mt-2 space-y-1">
              <li>Name and contact details (email, phone number)</li>
              <li>Shipping and billing address</li>
              <li>Payment information (processed securely via Razorpay)</li>
              <li>Order history and preferences</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">3. How We Use Your Information</h2>
            <p className="text-muted-foreground leading-relaxed">
              Your information is used to:
            </p>
            <ul className="list-disc list-inside text-muted-foreground mt-2 space-y-1">
              <li>Process and fulfill your orders</li>
              <li>Send order confirmations and shipping updates</li>
              <li>Provide customer support</li>
              <li>Improve our products and services</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">4. Payment Security</h2>
            <p className="text-muted-foreground leading-relaxed">
              All payments are processed through Razorpay, a PCI-DSS compliant payment gateway. 
              We do not store your credit/debit card details on our servers. Your financial 
              information is encrypted and secure.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">5. Data Protection</h2>
            <p className="text-muted-foreground leading-relaxed">
              We implement appropriate security measures to protect your personal information. 
              Your data is stored securely and accessed only by authorized personnel for 
              order processing and customer service purposes.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">6. Third-Party Sharing</h2>
            <p className="text-muted-foreground leading-relaxed">
              We do not sell or rent your personal information to third parties. We may share 
              your information with shipping partners solely for delivery purposes.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-bold mb-4">7. Contact Us</h2>
            <p className="text-muted-foreground leading-relaxed">
              For privacy-related queries, contact us at:<br />
              <strong>Email:</strong> admin@ogas.in<br />
              <strong>Phone:</strong> +91 99947 93643<br />
              <strong>Address:</strong> 25A, Padmavathipuram 1st Street, Gandhinagar Post, Tirupur - 641603, Tamil Nadu, India
            </p>
          </section>
        </div>

        <div className="mt-8 text-center">
          <Link to="/" className="text-primary hover:underline">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
}
